export const clusterLayer = {
  id: "clusters",
  type: "circle",
  source: "pins",
  filter: ["has", "point_count"],
  paint: {
    "circle-color": [
      "step",
      ["get", "point_count"],
      "#005172",
      100,
      "#e35100",
      750,
      "#4f99bb"
    ],
    "circle-radius": ["step", ["get", "point_count"], 20, 100, 30, 750, 40]
  }
};

export const clusterCountLayer = {
  id: "cluster-count",
  type: "symbol",
  source: "pins",
  filter: ["has", "point_count"],
  layout: {
    "text-field": "{point_count_abbreviated}",
    "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
    "text-size": 12
  },
  paint: {
    "text-color": "#ffffff"
  }
};

export const unclusteredPointLayer = {
  id: "unclustered-point",
  type: "symbol",
  source: "pins",
  filter: ["!", ["has", "point_count"]],
  layout: {
    "icon-image": "pin",
    "icon-size": 0.5
  },
  paint: {}
};

export const selectedPointLayer = {
  id: "selected-point",
  type: "symbol",
  source: "pins",
  filter: ["==", "icon", "selected"],
  layout: {
    "icon-image": "selected_pin",
    "icon-size": 0.5
  },
  paint: {}
}
